import React, { useState } from 'react';
import ChangeTierModal from 'components/payment/ChangeTierModal.jsx';

// The call-to-action shown on a tier card for an active subscriber who is on a
// tier plan. `state` is computed server-side relative to the subscriber's own
// tier: 'current' (their plan — no action), 'upgrade' or 'downgrade'.
const ChangeTierButton = ({ targetTier, targetTierName, state }) => {
  const [open, setOpen] = useState(false);

  if (state === 'current') {
    return (
      <span className="btn btn-price simple-btn subscription-card-current" aria-disabled="true">
        {t('payment.current_plan')}
      </span>
    );
  }

  const label = state === 'downgrade'
    ? t('payment.change_tier_downgrade_cta')
    : t('payment.change_tier_upgrade_cta');

  return (
    <span>
      <center>
        <a
          className="btn btn-price simple-btn"
          href="#"
          onClick={(event) => { event.preventDefault(); setOpen(true); }}
        >
          {label}
        </a>
      </center>
      {open && (
        <ChangeTierModal
          targetTier={targetTier}
          targetTierName={targetTierName}
          direction={state}
          onClose={() => setOpen(false)}
          onSuccess={() => window.location.reload()}
        />
      )}
    </span>
  );
};

export default ChangeTierButton;
